import React from 'react';
import ShowSimplePriceProperties from "./ShowSimplePriceProperties";
import {useStyles} from "./ShowSimplePrice.style";
import {CurrencyModule} from "../../../util/Currency";
import clsx from "clsx";
import Currency from '../../../entities/Currency';

const ShowSimplePrice: React.FC<ShowSimplePriceProperties> = ({
                                                      value,
                                                      className = '',
                                                  }) => {

    const classes = useStyles();
    const formattedValue = CurrencyModule.format(value, Currency.USD).split(".");
    const intValue = formattedValue[0];
    const decimalValue = formattedValue[1];

    return (
        <div className={clsx(classes.show_price_container, className)}>
            <div className={clsx(
                classes.number,
            )}>{value &&
            <>
                <span>{intValue}</span>.
                <span>{decimalValue}</span>
            </>
            }</div>
        </div>
    )
}


export default ShowSimplePrice;